export default __webpack_public_path__ + "static/media/THSarabunNew Bold.bba24ce8.ttf";